import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Template from './template'
import FormModal from './form-modal'

const MessageTemplates = ({templates, createTemplate, updateTemplate, deleteTemplate}) => {
  const [template, setTemplate] = useState(null)

  const onCreate = (data) => {
    createTemplate(data)
    setTemplate(null)
  }

  const onUpdate = (data) => {
    updateTemplate(data)
    setTemplate(null)
  }

  const onDelete = (data) => {
    if (window.confirm('Are you sure you want to delete this template?')) {
      deleteTemplate(data)
    }
  }

  return (
    <div>
      <h1>Templates</h1>
      <div className='templates-container'>
        { template && 
          <FormModal 
            template={template}
            onClose={() => setTemplate(null)}
            onCreate={onCreate}
            onUpdate={onUpdate}
          />
        }
        <div className='templates-header'>
          <h3>All Templates</h3>
          <button className='btn btn-success' onClick={() => setTemplate({})}>Add Template</button>
        </div>
        <div>Create templates for messages you'll send frequently</div>
        {
          templates.map((t, index) => {
            return <Template 
              key={index}
              template={t}
              onEdit={() => setTemplate(t)}
              onDelete={onDelete}
            />
          })
        }
      </div>
    </div>
  )
}

MessageTemplates.propTypes = {
  templates: PropTypes.array.isRequired,
  createTemplate: PropTypes.func.isRequired,
  updateTemplate: PropTypes.func.isRequired,
  deleteTemplate: PropTypes.func.isRequired,
}

export default MessageTemplates
